import { create } from "zustand";

type TTaskFilters = {
  status: string;
  dueDate: Date | null;
  search: string;
  page: number;
  pageSize: number;
  archiveStatus: "all" | "active" | "archived";
};

type State = {
  formState: {
    open: boolean;
    taskId?: string;
  };
  viewTaskState: {
    open: boolean;
    taskId?: string;
  };
  filters: TTaskFilters;
};

type Actions = {
  setFilters: (filters: Partial<TTaskFilters>) => void;
  resetFilters: () => void;
  openTaskModal: (taskId?: string) => void;
  closeTaskModal: () => void;
  openViewTaskModal: (taskId?: string) => void;
  closeViewTaskModal: () => void;
};

const initialState: TTaskFilters = {
  status: "all",
  dueDate: null,
  search: "",
  page: 1,
  pageSize: 10,
  archiveStatus: "active",
};

export const useTaskStore = create<State & Actions>((set) => ({
  formState: {
    open: false,
  },
  viewTaskState: {
    open: false,
  },
  filters: initialState,
  setFilters: (filters: Partial<TTaskFilters>) =>
    set((state) => ({
      filters: {
        ...state.filters,
        ...filters,
      },
    })),
  resetFilters: () => set({ filters: initialState }),
  openTaskModal: (taskId) =>
    set({
      formState: {
        open: true,
        taskId,
      },
    }),
  closeTaskModal: () => set({ formState: { open: false, taskId: undefined } }),
  openViewTaskModal: (taskId) =>
    set({
      viewTaskState: {
        open: true,
        taskId,
      },
    }),
  closeViewTaskModal: () =>
    set({ viewTaskState: { open: false, taskId: undefined } }),
}));
